import { makeStyles } from "@material-ui/core/styles";
import { MuiTheme } from "theme";

export default makeStyles((theme: MuiTheme) => ({
  dialogPaper: {
    width: 296
  },
  dialogTitle: {
    padding: "11px 20px",
    "& .MuiTypography-h6": {
      fontFamily: "SuisseIntlMedium, SuisseIntlRegular",
      fontSize: 18
    }
  },
  dialogContent: {
    backgroundColor: "#ffffff",
    color: theme.palette.primary.main,
    borderRadius: 2,
    padding: 0,
    fontSize: 12
  },
  dialogCloseButton: {
    position: "absolute",
    top: 8,
    right: 8
  },
  dialogCloseButtonIcon: {
    fontSize: 28
  },
  horseName: {
    fontFamily: "SuisseIntlMedium, SuisseIntlRegular",
    marginBottom: 5,
    wordBreak: "break-word",
    fontSize: 14
  },
  trainerName: {
    marginBottom: 26,
    wordBreak: "break-word",
    fontSize: 14
  },
  historyContentHeader: {
    marginBottom: 8,
    paddingLeft: 20
  },
  historyButton: {
    color: theme.palette.primary.light,
    "&.MuiIconButton-root": {
      padding: 0
    }
  }
}));
